import React, { useEffect, useState } from "react";
import axios from "axios";

import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import AlertListingItem from "./AlertListingItem";
import AlertListingTable from "./AlertListingTable";
import { Separator } from "../../components";
import Dropdown from "react-dropdown";

const ItemDetail = ({ alertId }) => {
  const [activeTab, setActiveTab] = useState("results");
  const [count, setCount] = useState(0);
  const [mainCount, setMainCount] = useState(0);
  const [similarCount, setSimilarCount] = useState(0);

  const tabs = [
    {
      id: "results",
      label: "Results",
    },
    {
      id: "similar_listings",
      label: "Similar Listings",
    },
  ];

  const fetchMainCount = async () => {
    const response = await axios.post(
      `/api/alert/${alertId}/listings/main_alert`
    );
    setMainCount(response.data.total);
  };

  const fetchSimilarCount = async () => {
    const response1 = await axios.post(
      `/api/alert/${alertId}/listings/similar_listings`
    );
    setSimilarCount(response1.data.total);
  };

  useEffect(() => {
    fetchMainCount();
    fetchSimilarCount();
  }, []);

  useEffect(() => {
    activeTab === "results" ? fetchMainCount() : fetchSimilarCount();
  }, [activeTab]);

  const onTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const dropdownOptions = tabs.map((tab) => {
    return {
      value: tab.id,
      label: tab.label,
    };
  });

  return (
    <div className="details pb-3" colSpan={8}>
      <div className="alert-details-container px-4">
        <div className="tabs d-none d-sm-block py-4">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={` ${tab.id === activeTab ? "active" : ""}`}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.label} ({tab.id === "results" ? mainCount : similarCount})
            </button>
          ))}
        </div>

        <div className="d-sm-none mx-2 contact-details-dropdown mt-4 py-4">
          <Dropdown
            options={dropdownOptions}
            onChange={(o) => onTabChange(o.value)}
            value={activeTab}
            defaultValue={activeTab}
          />

          <Separator noMargin className="mb-0 mt-4" />
        </div>
        <div
          id="alert-scroll-container"
          style={{
            height: "510px",
            overflowY: "auto",
          }}
        >
          <AlertListingTable
            {...{
              className: "alert-listing-list",
              fetchUrl: `/api/alert/${alertId}/listings/${
                activeTab === "results" ? "main_alert" : "similar_listings"
              }`,
              headers: [
                "Source",
                "Date",
                "Product",
                "Title",
                "Reference",
                "Price",
                "Country",
              ],
              RowComponent: AlertListingItem,
              scrollableTarget: "alert-scroll-container",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ItemDetail;
